module.exports = __webpack_public_path__ + "img/full3-min.c57537bb.png";